export default "__VITE_ASSET__CSISOTTK__"